let accessToken: string | null = null;
let refreshTimer: ReturnType<typeof setTimeout> | null = null;
let proactiveRefreshCallback: (() => Promise<void>) | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  clearRefreshTimer();
  accessToken = token;
  if (token) {
    scheduleProactiveRefresh(token);
  }
}

export function setProactiveRefreshCallback(cb: () => Promise<void>): void {
  proactiveRefreshCallback = cb;
}

function decodeJwtExp(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))) as Record<
      string,
      unknown
    >;
    return typeof decoded.exp === 'number' ? decoded.exp : null;
  } catch {
    return null;
  }
}

function clearRefreshTimer(): void {
  if (refreshTimer !== null) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
}

function scheduleProactiveRefresh(token: string): void {
  if (!proactiveRefreshCallback) return;

  const exp = decodeJwtExp(token);
  if (exp === null) return;

  const expiresInMs = exp * 1000 - Date.now();
  const refreshInMs = expiresInMs - 60_000; // Refresh 60 s before expiry

  if (refreshInMs <= 0) {
    void proactiveRefreshCallback();
    return;
  }

  refreshTimer = setTimeout(() => {
    void proactiveRefreshCallback?.();
  }, refreshInMs);
}
